export const MuiTypography = {
  h1: {
    'font-family': 'knowledge2017bold',
    'font-size': '40px',
    'line-height': '48px',
  },
  h2: {
    'font-family': 'knowledge2017bold',
    'font-size': '20px',
    'line-height': '24px',
  },
  h3: {
    'font-family': 'knowledge2017medium',
    'font-size': '16px',
    'line-height': '20px',
  },
  h4: {
    'font-family': 'knowledge2017medium',
    'font-size': '14px',
    'line-height': '18px',
  },
  body2: {
    'font-family': 'knowledge2017regular',
    'font-size': '16px',
    'line-height': '20px',
  },
  body1: {
    'font-family': 'knowledge2017regular',
    'font-size': '14px',
    'line-height': '16px',
  },
  caption: {
    'font-family': 'knowledge2017regular',
    'font-size': '12px',
    'font-weight': 'bold',
    'line-height': '24px',
  },
  button: {
    'font-family': 'knowledge2017medium',
    'font-size': '16px',
    'line-height': '20px',
    'text-transform': 'uppercase',
    'letter-spacing': '0.5px',
  },
  title: {
    'font-family': 'knowledge2017bold',
    'font-size': '20px',
    'line-height': '24px',
  },

  subtitle1: {
    'font-family': 'knowledge2017regular',
    'font-size': '12px',
    'line-height': '14px',
  },

  subtitle2: {
    'font-family': 'knowledge2017regular',
    'font-size': '10px',
    'line-height': '11px',
  },
}
